<template>
  <v-container class="flash-messages" v-if="hasMessages">
    <v-layout align-center justify-center>
      <v-flex>
        <v-alert
          :type="typeToClass[t] || t"
          v-model="visible[t]"
          v-for="(msg, t) in messages" :key="t"
          dismissible
          transition="scale-transition"
        >
          {{ msg }}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  const typeToClass = { // maps rails flash message types to bootstrap classes
    'comment': 'info',
    'system': 'info',
    'success': 'success',
    'notice': 'info',
    'warning': 'warning',
    'alert': 'error',
    'error': 'error',
    'pending': 'info'
  }

  export default {
    data () {
      return {
        typeToClass: typeToClass,
        visible: {
          comment: true,
          system: true,
          success: true,
          notice: true,
          warning: true,
          alert: true,
          error: true,
          pending: true
        }
      }
    },

    computed: {
      ...mapState('flashMessages', ['messages']),
      hasMessages () {
        return Object.keys(this.messages).length
      }
    },
    methods: {
      hide (type) {
        this.hidden[type] = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/core/AppFlashMessages.vue